var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSehqcLogoStackedColorClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 824.08 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-9 {\n        fill: none;\n        opacity: .3;\n        stroke: #64737f;\n        stroke-miterlimit: 10;\n        stroke-width: 1.96px;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-11 {\n        fill: #4b99ca;\n      }\n\n      .cls-12 {\n        fill: #64737f;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-11);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 164.29,
    y1: 574.42,
    x2: 356.97,
    y2: 574.42,
    gradientTransform: "translate(-199.48 -399.21) rotate(-3.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#091c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6b276d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#962372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e25681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 164.29,
    y1: 508.13,
    x2: 356.97,
    y2: 508.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -860.21,
    y1: -1409.51,
    x2: -813.27,
    y2: -1586.36,
    gradientTransform: "translate(523.5 1757.73) rotate(15.19) skewX(.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0e537b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d6c9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -938.71,
    y1: -1430.34,
    x2: -891.77,
    y2: -1607.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -856.77,
    y1: -1408.6,
    x2: -809.83,
    y2: -1585.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -827.2,
    y1: -1400.75,
    x2: -780.26,
    y2: -1577.6,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 243.85,
    y1: 567.12,
    x2: 198.96,
    y2: 423.28,
    gradientTransform: "translate(-199.48 -399.21) rotate(-3.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0d6c9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0f6d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4b99ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 298.56,
    y1: 550.05,
    x2: 253.67,
    y2: 406.2,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 309.54,
    y1: 546.62,
    x2: 264.65,
    y2: 402.78,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 208.04,
    y1: 578.3,
    x2: 163.15,
    y2: 434.45,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 281.17,
    y1: 555.48,
    x2: 236.28,
    y2: 411.63,
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.92,167.52c-39.55,7.59-69.61-9.38-87.7-33.1h-.49c13.8,27.67,41.08,47.86,74.12,51.12,39.54,3.91,75.74-17.55,92.44-51.12h-19.57c-14.9,16.13-35.44,28.62-58.79,33.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.3,120.94h14.42c1.88-6,3.18-12.28,3.83-18.79,1.83-18.5-1.9-36.28-9.82-51.66,2.4,5.38,4.13,10.8,5.07,16.11,3.15,17.81-2.2,37.23-13.5,54.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.31,120.83h26.58c4.03,0,4.7-.76,4.7-5.32,0-.18,0-1.97,0-2.14-.06-3.94-.83-4.62-4.69-4.62h-26.36c-14.06,0-19.63-2.57-19.63-13.53,0-5.31,0-8.94,0-9.27,0-10.88,5.35-15.25,19.57-15.25h40.3c3.94,0,6.2,2.98,6.2,6.8s-2.15,6.68-5.97,6.68h-41.06c-2.91,0-4.01.34-4.01,4.16,0,.66,0,2.4,0,2.6-.17,3.4.99,4.34,4.01,4.34h28.5c13.99,0,18.61,2.13,18.61,13.48v9.7c4.38-2.35,8.39-5.28,11.94-8.68v-20.58c0-10.92,5.84-17.79,16.61-18.54-.15-29.46-24.15-53.44-53.96-53.7-17.85-.16-33.77,8.21-43.82,21.28-1.26,1.73-2.46,3.5-3.61,5.32-4.69,7.89-7.42,17.08-7.51,26.9-.2,22.67,13.71,42.19,33.61,50.38Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M116.61,134.37c-11.76,8.64-26.12,13.83-41.7,14.09-16.42.28-31.67-4.96-44.08-14.05H10.22c18.09,23.73,48.15,40.69,87.7,33.1,23.35-4.48,43.89-16.97,58.79-33.1h-38.4c-.58,0-1.15-.02-1.71-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M.54,83.04c-.03.27-.06.54-.09.81-1.27,12.87.14,25.38,3.79,36.99h12.39C8.16,110.27,2.41,97.29.54,83.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.34,70.59h2.03c11.61,0,15.61,7.3,15.61,15.37v9.27c0,11.26-5.73,13.42-11.21,13.42h-15.1c-2.29,4.37-4.99,8.49-8.05,12.29h36.68c11.3-17.12,16.65-36.54,13.5-54.34-.94-5.31-2.67-10.72-5.07-16.11C161.76,23.38,134.76,3.68,102.15.46,99,.15,95.87,0,92.76,0c30.64,8.43,53.53,36.61,54.58,70.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.72,90.27v-.35c0-4.56-.94-6.44-4.69-6.44h-.35c-.62,4.6-1.65,9.06-3.04,13.36h3.39c3.06,0,4.69-.89,4.69-6.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.91,148.47c15.57-.26,29.94-5.45,41.7-14.09-11.74-.56-17.61-6.93-17.61-18.33v-6.27c-3.55,3.4-7.57,6.33-11.94,8.68v2.38c0,12.68-6.32,13.58-18.61,13.58H30.82c12.41,9.08,27.66,14.33,44.08,14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.21,112.63c0,5.66,2.77,8.31,8.84,8.31h7.57c3.06-3.81,5.76-7.92,8.05-12.29h-24.46v3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.13,83.47c-5.67,0-7.93,2.77-7.93,7.81v5.56h29.43c1.4-4.3,2.42-8.76,3.04-13.36h-24.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M40.31,120.83c-19.9-8.18-33.81-27.71-33.61-50.38.09-9.82,2.82-19.01,7.51-26.9C6.93,55.15,2.1,68.53.54,83.04c1.87,14.26,7.62,27.23,16.09,37.8h23.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M61.64,16.95c29.81.27,53.81,24.24,53.96,53.7.65-.04,1.31-.07,1.99-.07h29.74C146.29,36.61,123.41,8.43,92.76,0,62.41.04,34.87,14.88,17.83,38.24c10.05-13.07,25.97-21.44,43.82-21.28Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M315.88,60.6c1.96,2.49,2.94,5.64,2.94,9.45,0,5.1-1.92,9.02-5.75,11.76-3.84,2.75-9.42,4.12-16.76,4.12h-28.06V27.13h26.38c6.72,0,11.91,1.34,15.58,4.03,3.67,2.69,5.5,6.41,5.5,11.17,0,3.08-.71,5.74-2.14,7.98-1.43,2.24-3.35,3.95-5.75,5.12,3.42.95,6.1,2.68,8.06,5.17ZM276.65,33.93v18.82h17.22c4.31,0,7.63-.8,9.95-2.39,2.32-1.6,3.49-3.93,3.49-7.01s-1.16-5.42-3.49-7.01c-2.33-1.6-5.64-2.39-9.95-2.39h-17.22ZM306.73,76.77c2.41-1.57,3.61-4.03,3.61-7.39,0-6.55-4.79-9.83-14.36-9.83h-19.32v19.57h19.32c4.76,0,8.34-.78,10.75-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M337.89,79.88c-4.37-4.48-6.55-10.92-6.55-19.32V27.13h8.4v33.1c0,12.6,5.52,18.9,16.55,18.9,5.38,0,9.49-1.55,12.35-4.66,2.86-3.11,4.28-7.85,4.28-14.24V27.13h8.15v33.43c0,8.46-2.18,14.91-6.55,19.36s-10.47,6.68-18.31,6.68-13.94-2.24-18.31-6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M437.6,85.93l-12.68-18.06c-1.57.11-2.8.17-3.7.17h-14.53v17.89h-8.4V27.13h22.93c7.62,0,13.61,1.82,17.98,5.46,4.37,3.64,6.55,8.65,6.55,15.04,0,4.54-1.12,8.4-3.36,11.59-2.24,3.19-5.43,5.52-9.58,6.97l13.94,19.74h-9.16ZM433.14,57.45c2.8-2.3,4.2-5.57,4.2-9.83s-1.4-7.52-4.2-9.79c-2.8-2.27-6.86-3.4-12.18-3.4h-14.28v26.46h14.28c5.32,0,9.38-1.15,12.18-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M509.92,27.13v58.8h-6.89l-35.28-43.85v43.85h-8.4V27.13h6.89l35.28,43.85V27.13h8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M538.39,82.69c-4.76-2.6-8.5-6.2-11.21-10.79-2.72-4.59-4.07-9.72-4.07-15.37s1.36-10.78,4.07-15.37c2.71-4.59,6.45-8.19,11.21-10.79,4.76-2.6,10.11-3.91,16.04-3.91s11.2,1.3,15.96,3.91c4.76,2.6,8.48,6.19,11.17,10.75,2.69,4.56,4.03,9.7,4.03,15.41s-1.34,10.85-4.03,15.41c-2.69,4.56-6.41,8.15-11.17,10.75-4.76,2.6-10.08,3.91-15.96,3.91s-11.29-1.3-16.04-3.91ZM566.07,76.18c3.44-1.96,6.16-4.66,8.15-8.11,1.99-3.44,2.98-7.29,2.98-11.55s-1-8.11-2.98-11.55c-1.99-3.44-4.7-6.14-8.15-8.11-3.44-1.96-7.32-2.94-11.63-2.94s-8.22.98-11.72,2.94c-3.5,1.96-6.25,4.66-8.23,8.11-1.99,3.44-2.98,7.29-2.98,11.55s.99,8.11,2.98,11.55c1.99,3.44,4.73,6.15,8.23,8.11,3.5,1.96,7.4,2.94,11.72,2.94s8.19-.98,11.63-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M604.92,79.88c-4.37-4.48-6.55-10.92-6.55-19.32V27.13h8.4v33.1c0,12.6,5.52,18.9,16.55,18.9,5.38,0,9.49-1.55,12.35-4.66,2.86-3.11,4.28-7.85,4.28-14.24V27.13h8.15v33.43c0,8.46-2.18,14.91-6.55,19.36s-10.47,6.68-18.31,6.68-13.94-2.24-18.31-6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M676.99,34.43h-20.16v-7.31h48.64v7.31h-20.16v51.49h-8.32v-51.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M309.16,110.59c4.37,3.64,6.55,8.65,6.55,15.04s-2.18,11.4-6.55,15.04c-4.37,3.64-10.36,5.46-17.98,5.46h-14.53v17.81h-8.4v-58.8h22.93c7.62,0,13.61,1.82,17.98,5.46ZM303.11,135.41c2.8-2.27,4.2-5.53,4.2-9.79s-1.4-7.52-4.2-9.79c-2.8-2.27-6.86-3.4-12.18-3.4h-14.28v26.38h14.28c5.32,0,9.38-1.13,12.18-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M367.37,163.93l-12.68-18.06c-1.57.11-2.8.17-3.7.17h-14.53v17.89h-8.4v-58.8h22.93c7.62,0,13.61,1.82,17.98,5.46,4.37,3.64,6.55,8.65,6.55,15.04,0,4.54-1.12,8.4-3.36,11.59-2.24,3.19-5.43,5.52-9.58,6.97l13.94,19.74h-9.16ZM362.92,135.45c2.8-2.3,4.2-5.57,4.2-9.83s-1.4-7.52-4.2-9.79c-2.8-2.27-6.86-3.4-12.18-3.4h-14.28v26.46h14.28c5.32,0,9.38-1.15,12.18-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M431.8,156.62v7.31h-42.67v-58.8h41.5v7.31h-33.1v18.06h29.48v7.14h-29.48v18.98h34.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M495.64,105.13l-25.79,58.8h-8.32l-25.87-58.8h9.07l21.17,48.3,21.34-48.3h8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M545.79,156.62v7.31h-42.67v-58.8h41.5v7.31h-33.1v18.06h29.48v7.14h-29.48v18.98h34.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M609.96,105.13v58.8h-6.89l-35.28-43.85v43.85h-8.4v-58.8h6.89l35.28,43.85v-43.85h8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M639.28,112.43h-20.16v-7.31h48.64v7.31h-20.16v51.49h-8.32v-51.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M676.91,105.13h8.4v58.8h-8.4v-58.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M713.45,160.69c-4.76-2.6-8.5-6.2-11.21-10.79-2.72-4.59-4.07-9.72-4.07-15.37s1.36-10.78,4.07-15.37c2.71-4.59,6.45-8.19,11.21-10.79,4.76-2.6,10.11-3.91,16.04-3.91s11.2,1.3,15.96,3.91c4.76,2.6,8.48,6.19,11.17,10.75,2.69,4.56,4.03,9.7,4.03,15.41s-1.34,10.85-4.03,15.41c-2.69,4.56-6.41,8.15-11.17,10.75-4.76,2.6-10.08,3.91-15.96,3.91s-11.29-1.3-16.04-3.91ZM741.13,154.18c3.44-1.96,6.16-4.66,8.15-8.11,1.99-3.44,2.98-7.29,2.98-11.55s-1-8.11-2.98-11.55c-1.99-3.44-4.7-6.14-8.15-8.11-3.44-1.96-7.32-2.94-11.63-2.94s-8.22.98-11.72,2.94c-3.5,1.96-6.25,4.66-8.23,8.11-1.99,3.44-2.98,7.29-2.98,11.55s.99,8.11,2.98,11.55c1.99,3.44,4.73,6.15,8.23,8.11,3.5,1.96,7.4,2.94,11.72,2.94s8.19-.98,11.63-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M824.08,105.13v58.8h-6.89l-35.28-43.85v43.85h-8.4v-58.8h6.89l35.28,43.85v-43.85h8.4Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 222.08,
    x2: 222.08,
    y2: 186
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSehqcLogoStackedColorClear);
export default __webpack_public_path__ + "static/media/SEHQC-Logo-Stacked-Color-Clear.f847bff923a71b7a2ea914abb54669d2.svg";
export { ForwardRef as ReactComponent };